import React from "react";
import { Download, Eye, Pencil, Trash2, Truck } from "lucide-react";
import { cn } from "../../../libs/utils";

const iconButtonClass =
  "flex h-7 w-7 items-center justify-center rounded-md transition-colors disabled:cursor-not-allowed disabled:opacity-40";

/**
 * Row-level action icons shared across the Batch table and the Dispatch
 * History table (both render this component so the icon set/behaviour/
 * styling only lives in one place). Every action is optional except
 * download — pass only the handlers relevant to the table using it (e.g.
 * Dispatch History only needs `onDownload` + `onView`).
 */
const BatchRowActions = ({
  onDownload,
  downloadDisabled,
  onView,
  onEdit,
  onDispatch,
  onDelete,
  className,
}) => (
  <div className={cn("flex items-center gap-1.5", className)}>
    <button
      type="button"
      title="Download dispatch slip"
      aria-label="Download dispatch slip"
      disabled={downloadDisabled}
      onClick={(event) => {
        event.stopPropagation();
        onDownload?.();
      }}
      className={cn(iconButtonClass, "text-emerald-600 hover:bg-emerald-50")}
    >
      <Download className="h-4 w-4" />
    </button>
    {onView && (
      <button
        type="button"
        title="View batch details"
        aria-label="View batch details"
        onClick={(event) => {
          event.stopPropagation();
          onView();
        }}
        className={cn(iconButtonClass, "text-brand hover:bg-lightSecondary")}
      >
        <Eye className="h-4 w-4" />
      </button>
    )}
    {onEdit && (
      <button
        type="button"
        title="Edit batch"
        aria-label="Edit batch"
        onClick={(event) => {
          event.stopPropagation();
          onEdit();
        }}
        className={cn(iconButtonClass, "text-slate-400 hover:bg-slate-100 hover:text-slate-600")}
      >
        <Pencil className="h-4 w-4" />
      </button>
    )}
    {onDispatch && (
      <button
        type="button"
        title="Dispatch batch"
        aria-label="Dispatch batch"
        onClick={(event) => {
          event.stopPropagation();
          onDispatch();
        }}
        className={cn(iconButtonClass, "text-sky-500 hover:bg-sky-50 hover:text-sky-600")}
      >
        <Truck className="h-4 w-4" />
      </button>
    )}
    {onDelete && (
      <button
        type="button"
        title="Delete batch"
        aria-label="Delete batch"
        onClick={(event) => {
          event.stopPropagation();
          onDelete();
        }}
        className={cn(iconButtonClass, "text-rose-400 hover:bg-rose-50 hover:text-rose-600")}
      >
        <Trash2 className="h-4 w-4" />
      </button>
    )}
  </div>
);

export default BatchRowActions;
